import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { ConfigService } from './core/config.service';
import { catchError, Subject, takeUntil, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WholesalerSimulationService implements OnDestroy {
  private readonly _destroying$ = new Subject<void>();
  private readonly _backendUri: string = this._configService.config.backendUri;

  constructor(
    private readonly _httpClient: HttpClient,
    private readonly _configService: ConfigService,
  ) {}

  ngOnDestroy(): void {
    this._destroying$.next();
    this._destroying$.complete();
  }

  getAvailableYearsByAdherent(idAdherent: number) {
    const url = `${this._backendUri}/adherent/${idAdherent}/wholesaler-simulation/years`;

    return this._httpClient.get<number[]>(url).pipe(
      takeUntil(this._destroying$),
      catchError((error: HttpErrorResponse) => throwError(() => error)),
    );
  }

  getWholesalerSimulationByAdherent(idAdherent: number) {
    const url = `${this._backendUri}/adherent/${idAdherent}/wholesaler-simulation`;

    return this._httpClient.get<any[]>(url).pipe(
      takeUntil(this._destroying$),
      catchError((error: HttpErrorResponse) => throwError(() => error)),
    );
  }

  getWholesalerSimulationByAdherentAndYear(idAdherent: number, year: number) {
    const url = `${this._backendUri}/adherent/${idAdherent}/wholesaler-simulation/${year}`;

    return this._httpClient.get<any[]>(url).pipe(
      takeUntil(this._destroying$),
      catchError((error: HttpErrorResponse) => throwError(() => error)),
    );
  }
}
